// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LLE6","colMin":"styles_colMin__2PZ3p"};